import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const GoogleDriveLogoLeftGreenIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M942 836L323 1920 0 1354 619 270l323 566z" />
    </svg>
  ),
  displayName: 'GoogleDriveLogoLeftGreenIcon',
});

export default GoogleDriveLogoLeftGreenIcon;
